import React from 'react';
import { CheckCircle, Clock, RefreshCw, XCircle } from 'lucide-react';
import { cn } from '../../../utils';
import { getWithdrawalStatusDisplay } from '../../../utils/withdrawalStatusDisplay';

type Props = {
  status: string | null | undefined;
  className?: string;
};

export function WithdrawalStatusBadge({ status, className }: Props) {
  const display = getWithdrawalStatusDisplay(status);
  const Icon =
    display.tone === 'success'
      ? CheckCircle
      : display.tone === 'danger'
        ? XCircle
        : display.status === 'retry_scheduled'
          ? RefreshCw
          : Clock;

  return (
    <span
      className={cn(
        'px-2.5 py-0.5 rounded-full text-xs font-medium inline-flex items-center gap-1',
        display.className,
        className
      )}
    >
      <Icon className="h-3 w-3 shrink-0" />
      {display.label}
    </span>
  );
}

export default WithdrawalStatusBadge;
